import { atom, useRecoilState } from 'recoil';
import { useCallback } from 'react';

const REPORTER_COVERAGE_DEBUG_HIDDEN_ATOM_KEY = 'reporterCoverageDebugHidden';

const reporterCoverageDebugHiddenAtom = atom<boolean>({
  key: REPORTER_COVERAGE_DEBUG_HIDDEN_ATOM_KEY,
  default: false,
});

type UseReporterCoverageDebugState = {
  isHidden: boolean;
  toggle: () => void;
};

/** Internal-only debug toggle to hide the reporter no-coverage crosshatch overlay. */
export const useReporterCoverageDebugState =
  (): UseReporterCoverageDebugState => {
    const [isHidden, setIsHidden] = useRecoilState(
      reporterCoverageDebugHiddenAtom,
    );
    const toggle = useCallback(
      () => setIsHidden((prev) => !prev),
      [setIsHidden],
    );

    return { isHidden, toggle };
  };
